import * as Yup from 'yup';

import { Form, Formik } from 'formik';
import React, { Component } from 'react';

import { Alert } from '_helpers';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { authenticationService } from '_services';
import { withStyles } from '@material-ui/core/styles';

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
});

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
    };
    if (authenticationService.currentUserValue) {
      this.props.history.push('/admin/envInfo');
    }
    this.onUserNameChange = this.onUserNameChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
  }

  onUserNameChange(event) {
    this.setState({ username: event.target.value });
  }

  onPasswordChange(event) {
    this.setState({ password: event.target.value });
  }

  render() {
    const { classes } = this.props;

    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Formik
            enableReinitialize
            initialValues={{
              username: this.state.username,
              password: this.state.password,
            }}
            validationSchema={Yup.object().shape({
              username: Yup.string().required('Username is required'),
              password: Yup.string().required('Password is required'),
            })}
            onSubmit={({ username, password }, { setStatus, setSubmitting }) => {
              setStatus();
              authenticationService.login(username, password).then(
                (user) => {
                  const { from } = this.props.location.state || { from: { pathname: '/' } };
                  this.props.history.push(from);
                },
                (error) => {
                  setSubmitting(false);
                  setStatus(error);
                },
              );
            }}
            render={({ errors, status, touched, isSubmitting }) => (
              <Form>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="Ldap Username"
                  name="username"
                  autoFocus
                  helperText={touched.username ? errors.username : ''}
                  error={touched.username && Boolean(errors.username)}
                  onChange={this.onUserNameChange}
                  value={this.state.username}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  helperText={touched.password ? errors.password : ''}
                  error={touched.password && Boolean(errors.password)}
                  onChange={this.onPasswordChange}
                  value={this.state.password}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Sign In
                </Button>
                {status && <Alert severity="error">{status}</Alert>}
              </Form>
            )}
          />
        </div>
      </Container>
    );
  }
}

export default withStyles(useStyles)(Login);
